import React from 'react';
import {Button} from 'react-bootstrap';
class Cart extends React.Component {
    constructor() {
        super();
    }

    renderCartList() {
        return this.props.selectedBooths.map((booth) => {
            let t_booth = booth['booth_data'];
            return (<tr>
                        <td align="left" style={{"paddingLeft":"5px"}} valign="top"><p>{t_booth.BoothNo}</p></td>
                        <td align="left" valign="top"><p>{t_booth.BoothSize}</p></td>
                        <td align="center" valign="top">
                            <p align="center">
                                {this.numberWithCommas(t_booth.Amount)}
                            </p>
                        </td>
                        <td align="center" valign="top">
                            <p align="center">
                                <span style={{"color":"red","fontSize":"9px","fontWeight":"bold"}}>Pending</span>
                            </p>
                        </td>
                        <td align="center" valign="top">
                            <p>
                                <Button variant='danger' onClick={(e) => {this.props.removeFromCart(booth)}}>Remove</Button>
                            </p>
                        </td>
                    </tr>);
        });
    }

    numberWithCommas(x) {
        if(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else return null;
    }

    renderRegisteredList() {
        return this.props.registeredBooths.map((t_booth) => {
            return (<tr>
                        <td align="left" style={{"paddingLeft":"5px"}} valign="top"><p>{t_booth.BoothNo}</p></td>
                        <td align="left" valign="top"><p>{t_booth.BoothSize}</p></td>
                        <td align="center" valign="top">
                            <p align="center">
                                {this.numberWithCommas(t_booth.Amount)}
                            </p>
                        </td>
                        <td align="center" valign="top">
                            <p align="center">
                                {t_booth.Confirmed == 1 && (
                                <span style={{"color":"red","fontSize":"9px","fontWeight":"bold"}}>CONFIRMED</span>)}
                                {t_booth.Confirmed != 1 && (
                                <span style={{"color":"red","fontSize":"9px","fontWeight":"bold"}}>Pending</span>)}
                            </p>
                        </td>
                        <td align="center" valign="top">
                            <p>
                                &nbsp;
                                {t_booth.Confirmed != 1 && (<Button variant='danger' onClick={(e) => {this.props.removeFromCart(this.props.booths[t_booth['BoothID']])}}>Remove</Button>)}
                            </p>
                        </td>
                    </tr>);
        });
        return null;
    }

    renderSubmitForm() {
        let listOfValueIDs = [];
        for(let i in this.props.selectedBooths){
            listOfValueIDs.push(this.props.selectedBooths[i]['booth_data']['ValueID']);
        }
        for(let i in this.props.registeredBooths){
            listOfValueIDs.push(this.props.registeredBooths[i]['ValueID']);
        }
        listOfValueIDs = listOfValueIDs.join(',');
        return (
                <form name="Go" action="#StartView" method="post">
                <input type="hidden" name="BoothSelectionList" value={listOfValueIDs} />
                <input type="hidden" name="Addother" value="1" />
                <input type="hidden" name="ConfID" value={this.props.SESSION.confid} />
                <input type="hidden" name="CompID" value={this.props.SESSION.compid} />
                <input type="hidden" name="MenuID" value={this.props.MenuID} />
                <input type="hidden" name="Screen" value={this.props.Screen} />
                <input type="submit" class="btn btn-warning" name="submit" value="Continue Registration" />
                </form>);
    }
    render () {
        let maximumReached = (this.props.selectedBooths.length + this.props.registeredBooths.length) >= this.props.maximumSelectionAllowed;
        return (<div className="panel panel-default">
                    <div className="panel-heading" style={{color: '#fff', backgroundColor: '#013952'}}>
                        <h3 className="panel-title">Booth Selection List</h3>
                    </div>
                    <div className="panel-body">
                        <div className="row"><div className="col-xs-12">

                            {(this.props.selectedBooths.length > 0 || this.props.registeredBooths.length > 0) && (<div><table className="table table-striped tabled-condensed">
                                <thead>
                                    <tr>
                                        <th>Booth No</th>
                                        <th>Booth Size</th>
                                        <th>Booth Cost</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.renderRegisteredList()}
                                {this.renderCartList()}
                            </tbody></table>
                                {(this.props.selectedBooths.length > 0) && (<div>
                                <p style={{"fontWeight":"bold","color":"black","fontSize":"14px"}}>
                                    <em>To secure space you must complete checkout now
                                </em></p>
                                <p style={{"fontSize":"12px"}}>
                                    You have {this.props.checkoutLength}
                                      minutes to complete purchase of any non-confirmed booths or they may no longer be available.
                                </p></div>)}
                            </div>
                            )}
                            {(this.props.selectedBooths.length == 0) && (this.props.registeredBooths.length == 0)  &&  !maximumReached && (<b>No booths currently selected. </b>)}
                            {(this.props.selectedBooths.length > 0 || this.props.registeredBooths.length > 0) && !maximumReached && (<div><br/><b>
                             Please select booths below.</b></div>)}
                            {maximumReached && (<span style={{"color":"red","fontSize":"12px","fontWeight":"bold"}}>You have reached the maximum number of booths allowed to be purchased.</span>)}
                        </div></div>
                        {this.renderSubmitForm()}
                    </div>
                </div>);

    }
}

export {Cart};